import {
  SIMDATA5GORDER_COUNT_ASSIGN_SUCCESS,
  SIMDATA5GORDER_HISTORY_LIST_SUCCESS,
  SIMDATA5GORDER_IMPORT_SUCCESS,
  SIMDATA5GORDER_LIST_SUCCESS,
  SIMDATA5GORDER_NEW_CARE_SUCCESS,
  SIMDATA5GORDER_ONE_SUCCESS,
  SIMDATA5GORDER_UPDATE_FILTER,
  SIMDATA5GORDER_SAVE_SUCCESS,
  SIMDATA5GORDER_UPDATE_HOMEPAGE_FILTER,
  SIMDATA5GORDER_HOMEPAGE_LIST_SUCCESS,
  SIMDATA5GORDER_HOMEPAGE_ONE_SUCCESS,
  SIMDATA5GORDER_LIMIT_UPDATE_HOMEPAGE_FILTER,
  SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_SUCCESS,
  SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/simdata5gorder.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageSimdata5gorderFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageSimdata5gorderPage: 0,
    homepageSimdata5gorderLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageSimdata5gorderLimitFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageSimdata5gorderLimitPage: 0,
    homepageSimdata5gorderLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageSimdata5gorderItems: [],
  homepageSimdata5gorderTotal: 0,
  homepageSimdata5gorderSelected: undefined,
  homepageSimdata5gorderLimitItems: [],
  homepageSimdata5gorderLimitTotal: 0,
  homepageSimdata5gorderLimitSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
}

const simdata5gorderReducer = (state = initState, action) => {
  switch (action.type) {
    case SIMDATA5GORDER_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case SIMDATA5GORDER_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageSimdata5gorderFilter !== 'undefined' && state.homepageSimdata5gorderFilter) {
        if (action.data.homepageSimdata5gorderPage == 'no_update' && typeof state.homepageSimdata5gorderFilter.homepageSimdata5gorderPage !== 'undefined') action.data.homepageSimdata5gorderPage = state.homepageSimdata5gorderFilter.homepageSimdata5gorderPage;
        if (action.data.homepageSimdata5gorderLimit == 'no_update' && typeof state.homepageSimdata5gorderFilter.homepageSimdata5gorderLimit !== 'undefined') action.data.homepageSimdata5gorderLimit = state.homepageSimdata5gorderFilter.homepageSimdata5gorderLimit;
      }
      return {
        ...state,
        homepageSimdata5gorderFilter: action.data,
      }
    }
    case SIMDATA5GORDER_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case SIMDATA5GORDER_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gorderItems: action.data.homepageSimdata5gorderItems,
        homepageSimdata5gorderTotal: action.data.homepageSimdata5gorderTotal,
      }
    }
    case SIMDATA5GORDER_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case SIMDATA5GORDER_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gorderSelected: action.data
      }
    }
    case SIMDATA5GORDER_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageSimdata5gorderLimitFilter !== 'undefined' && state.homepageSimdata5gorderLimitFilter) {
        if (action.data.homepageSimdata5gorderLimitPage == 'no_update' && typeof state.homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitPage !== 'undefined') action.data.homepageSimdata5gorderLimitPage = state.homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitPage;
        if (action.data.homepageSimdata5gorderLimitLimit == 'no_update' && typeof state.homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitLimit !== 'undefined') action.data.homepageSimdata5gorderLimitLimit = state.homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitLimit;
      }
      return {
        ...state,
        homepageSimdata5gorderLimitFilter: action.data,
      }
    }
    case SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gorderLimitItems: action.data.homepageSimdata5gorderLimitItems,
        homepageSimdata5gorderLimitTotal: action.data.homepageSimdata5gorderLimitTotal,
      }
    }
    case SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gorderLimitSelected: action.data
      }
    }
    case SIMDATA5GORDER_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case SIMDATA5GORDER_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case SIMDATA5GORDER_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case SIMDATA5GORDER_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case SIMDATA5GORDER_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    default: {
      return state;
    }
  }
}
export default simdata5gorderReducer